<template>
  <router-view v-slot="{ Component }">
    <transition name="fade" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
/* Design Tokens */
:root {
  /* Backgrounds */
  --bg-base: #131316;
  --bg-surface: #1c1c20;
  --bg-elevated: #2a2a2e;
  --bg-overlay: #2d2d2d;
  --bg-input: #18181c;
  --bg-hover: #3a3a3e;

  /* Borders */
  --border-subtle: #2e2e34;
  --border-default: #444;
  --border-strong: #555;

  /* Text */
  --text-primary: #ffffff;
  --text-secondary: #e0e0e0;
  --text-muted: #a0a0a0;
  --text-dim: #888;
  --text-ghost: #666;

  /* Accent Colors */
  --accent-primary: #4a90e2;
  --accent-primary-hover: #3a7bc8;
  --accent-primary-glow: rgba(74, 144, 226, 0.15);
  --accent-success: #4caf50;
  --accent-danger: #e74c3c;
  --accent-warning: #ff9800;
  --accent-gold: #e2994a;
  --accent-error: #ff5252;

  /* Effects */
  --shadow-dialog: 0 8px 32px rgba(0, 0, 0, 0.5);
  --shadow-card: 0 10px 40px rgba(0, 0, 0, 0.3);
  --shadow-glow: 0 0 20px rgba(74, 144, 226, 0.2);

  /* Transitions */
  --transition-fast: 0.15s ease;
  --transition-normal: 0.2s ease;
  --transition-slow: 0.3s ease;

  /* Radii */
  --radius-sm: 4px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --radius-xl: 16px;
}

/* Reset et styles globaux */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  overflow: hidden;
  background: var(--bg-base);
}

#app {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* Route transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity var(--transition-normal);
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
